import { AuthService } from './../../shared/services/auth/auth.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { DisplayNotificationService } from './../../shared/services/common/notification.service';
import { EmployeesService } from './../../shared/services/employees/employees.service';
import { UsersService } from './../../shared/services/common/users.service';
import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terminate',
  templateUrl: './terminate.component.html',
  styleUrls: ['./terminate.component.css']
})
export class TerminateComponent implements OnInit {

  constructor(
    private router: Router,
    private usersService: UsersService,
    private authService: AuthService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ssnMask = '000-00-0000';
  ssnPattern = /^(?!666|000\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
  ssn: number;
  value: any;
  operators: any;
  gridData: any;
  employeeName: any;
  personId: any;
  config: any;
  noContectMsg: any;
  selectedElements = [];
  searchBtnEnable: boolean;
  validSSNMsg: boolean;
  isEmpDetailValid: boolean;
  empNotFound: boolean;
  submitTerEmpDialog: boolean;
  displayload: boolean;
  termDateNotValid: boolean;
  isSubmitBtnDisable = false;

  ngOnInit() {
    this.searchBtnEnable = true;
    this.isSubmitBtnDisable = false;
    setTimeout(() => {
      this.notificationService.setUpLoading(false);
    }, 200);
    this.config = this.readConfigService.getTerminateText();
    this.operators = this.authService.getAccessOperations(2);
    const decryptValue = sessionStorage.getItem('terminateUser');
    if (decryptValue) {
      this.value = this.authService.decryptText(decryptValue);
      this.ssn = this.value;
      sessionStorage.removeItem('terminateUser');
      this.serachEmployeeSsn();
    }
  }

  onSsnChange(input: any) {
    this.isEmpDetailValid = false;
    this.value = input.trim();
    if (this.value.length > 8) {
      if (this.ssnPattern.test(this.value)) {
        this.searchBtnEnable = false;
        this.validSSNMsg = false;
        this.ssn = this.value;
      } else {
        this.validSSNMsg = true;
        this.searchBtnEnable = true;
      }
    } else {
      this.searchBtnEnable = true;
    }
  }

  cancelChanges() {
    this.isEmpDetailValid = false;
    this.selectedElements = [];
    this.value = '';
  }

  closeDialog() {
    this.displayload = false;
    this.submitTerEmpDialog = false;
  }

  onDateChange(dataItem: any, value: any) {
    if (value < dataItem.min || value > dataItem.max) {
      dataItem.termDateNotValid = true;
      this.isSubmitBtnDisable = false;
      return;
    } else {
      dataItem.termDateNotValid = false;
    }
    this.selectedElements.forEach(element => {
      if (element && element.encryptedEmploymentId === dataItem.encryptedEmploymentId) {
        element.terminateDt = value;
      }
    });
    this.isSubmitBtnDisable = this.selectedElements.every(obj => (obj.isTerminated && obj.terminateDt && !obj.termDateNotValid) || (!obj.isTerminated && obj.terminateDt === null && !obj.termDateNotValid));
  }

  onSwitchChange(value: any, dataItem: any) {
    dataItem.termDateNotValid = false;
    this.selectedElements.forEach(element => {
      if (element && element.encryptedEmploymentId === dataItem.encryptedEmploymentId) {
        element.isTerminated = value;
        element.terminateDt = null;
      }
    });
    this.isSubmitBtnDisable = this.selectedElements.every(obj => (obj.isTerminated && obj.terminateDt && !obj.termDateNotValid) || (!obj.isTerminated && obj.terminateDt === null && !obj.termDateNotValid));
  }

  setMinMaxDate(element: any) {
    if (element.status === 'A' || element.status === 'AE' || element.status === 'JS' || element.status === 'LS') {
      element.minDate = element.lastPayrollDate ? new Date(new Date(element.lastPayrollDate).setDate(new Date(element.lastPayrollDate).getDate() - 30)) : null;
      element.maxDate = element.lastPayrollDate ? new Date(new Date(element.lastPayrollDate).setDate(new Date(element.lastPayrollDate).getDate() + 60)) : null;
    } else if (element.status === 'I' || element.status === 'T' || element.status === 'DR') {
      element.minDate = element.lastPayrollDate ? new Date(new Date(element.lastPayrollDate).setDate(new Date(element.lastPayrollDate).getDate() - 30)) : null;
      element.maxDate = element.lastPayrollDate ? new Date(element.lastPayrollDate) : null;
    } else if (element.status === 'AL') {
      element.minDate = element.lastPayrollDate ? new Date(new Date(element.lastPayrollDate).setDate(new Date(element.lastPayrollDate).getDate() - 30)) : null;
      element.maxDate = new Date(new Date().setDate(new Date().getDate() + 60));
    }
    return element;
  }

  serachEmployeeSsn() {
    this.isSubmitBtnDisable = false;
    this.empNotFound = false;
    this.selectedElements = [];
    this.notificationService.setUpLoading(true);
    const inputData = { userInfo: this.usersService.UserInfo(), ssn: this.usersService.encrypt(this.ssn, 'post') };
    this.employeesService.getEmployeeInfo(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        this.isEmpDetailValid = true;
        this.employeeName = data.result.employeeName;
        this.personId = data.result.encryptedPersonId;
        if (data.result.employmentData.length > 0) {
          data.result.employmentData.forEach(element => {
            if (element && element.lastPayrollDate) {
              this.setMinMaxDate(element);
            }
          });
          this.selectedElements = data.result.employmentData.map(e => ({
            employmentId: e.employmentId,
            terminateDt: e.terminateDt !== null ? new Date(e.terminateDt) : null,
            encryptedEmploymentId: e.encryptedEmploymentId,
            encryptedTransferEmployerId: e.encryptedTransferEmployerId,
            location: e.location,
            status: e.status,
            systemPlan: e.systemPlan,
            isTerminated: true,
            lastPayrollDate: e.lastPayrollDate ? new Date(e.lastPayrollDate) : null,
            min: e.minDate,
            max: e.maxDate,
            isEdit: true,
            termDateNotValid: false
          }));
        }
        this.gridData = this.selectedElements.slice(0);
      } else if (data && data.statusCode === 204) {
        this.empNotFound = true;
        this.noContectMsg = data.message;
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.searchBtnEnable = true;
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      });
  }

  afterSuccessResponse(response: any) {
    this.notificationService.setUpNotification({ message: response.message, success: true });
    this.isEmpDetailValid = false;
    this.value = '';
    this.selectedElements = [];
  }

  updateEmpTerminateTask(successResponse: any) {
    const inputDate = {
      userInfo: this.usersService.UserInfo(),
      taskTypeID: 1,
      uniqueID: this.usersService.encrypt(this.ssn, 'post')
    };
    this.employeesService.updateTempTask(inputDate).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.afterSuccessResponse(successResponse);
      }
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.afterSuccessResponse(successResponse);
      });
  }

  terminateEmployee() {
    this.displayload = true;
    const selectedData = JSON.parse(JSON.stringify(this.selectedElements));
    const removeKeys = ['location', 'status', 'systemPlan', 'min', 'max', 'termDateNotValid'];
    selectedData.forEach((element) => {
      element.terminateDt = element.terminateDt ? element.terminateDt.slice(0, 10) : null;
      removeKeys.forEach((key) => {
        delete element[key];
      });
    });
    const inputDate = {
      userInfo: this.usersService.UserInfo(),
      EmployeeModel: { EncryptedPersonId: this.personId, EmploymentData: selectedData }
    };
    this.employeesService.postTerEmpData(inputDate).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.updateEmpTerminateTask(response);
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.submitTerEmpDialog = false;
      this.displayload = false;
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.displayload = false;
        this.submitTerEmpDialog = false;
        this.notificationService.setErrorNotification();
      });
  }
}
